module.exports = __webpack_public_path__ + "static/img/JO.7bca767b.png";